import * as Yup from 'yup';

import { getMaxText, getRequiredText } from 'utils/validate';

const GIFT_TYPE_VOUCHER = 'VOUCHER';

export const GIFT_NAME_MAX_LENGTH = 50;

const giftCreateValidationSchema = Yup.object({
  name: Yup.string()
    .trim()
    .required(getRequiredText('Tên quà tặng'))
    .max(GIFT_NAME_MAX_LENGTH, getMaxText('Tên quà tặng', GIFT_NAME_MAX_LENGTH)),

  deliveryMethod: Yup.string().required(
    getRequiredText('Hình thức vận chuyển'),
  ),

  stockQuantity: Yup.number()
    .transform((value, originalValue) => (
      originalValue === '' ||
      originalValue === null ||
      originalValue === undefined
        ? undefined
        : value
    ))
    .when('giftType', {
      is: GIFT_TYPE_VOUCHER,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema
          .required(getRequiredText('Số lượng trong kho'))
          .min(1, 'Số lượng trong kho phải lớn hơn 0')
          .max(999, 'Số lượng trong kho không được lớn hơn 999'),
    }),

  perAccountRedeemLimit: Yup.number()
    .transform((value, originalValue) => (
      originalValue === '' ||
      originalValue === null ||
      originalValue === undefined
        ? undefined
        : value
    ))
    .required(getRequiredText('Giới hạn đổi của một tài khoản'))
    .min(1, 'Giới hạn đổi của một tài khoản phải lớn hơn 0')
    .max(999, 'Giới hạn đổi của một tài khoản không được lớn hơn 999'),

  redeemPoints: Yup.number()
    .transform((value, originalValue) => {
      if (typeof originalValue === 'string') {
        const parsed = originalValue.replace(/,/g, '');
        return parsed === '' ? undefined : Number(parsed);
      }
      return originalValue === '' || originalValue === null || originalValue === undefined
        ? undefined
        : value;
    })
    .required(getRequiredText('Giá đổi điểm'))
    .min(0, 'Giá đổi điểm không được nhỏ hơn 0'),

  images: Yup.array().min(1, getRequiredText('Ảnh đại diện')),

  limitStartAt: Yup.mixed().when('isLimited', {
    is: true,
    then: (schema) => schema.required(getRequiredText('Thời gian bắt đầu')),
    otherwise: (schema) => schema.notRequired(),
  }),

  limitEndAt: Yup.mixed().when('isLimited', {
    is: true,
    then: (schema) => schema.required(getRequiredText('Thời gian kết thúc')),
    otherwise: (schema) => schema.notRequired(),
  }),

  voucherCampaign: Yup.string().when('giftType', {
    is: GIFT_TYPE_VOUCHER,
    then: (schema) => schema.required(getRequiredText('Chiến dịch voucher')),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export default giftCreateValidationSchema;
